import React from 'react';
import { inputClass } from './adminFormStyles';

const ManualVenueForm = ({ value, onChange }) => {
  const update = (key, val) => onChange({ ...value, [key]: val });

  return (
    <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50/50 p-4">
      <p className="text-sm text-gray-600">
        Enter the venue details manually. Latitude and longitude are optional but help show the location on a map.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className="text-xs font-medium text-gray-600 mb-1 block">Venue name *</label>
          <input
            type="text"
            value={value.name}
            onChange={(e) => update('name', e.target.value)}
            placeholder="e.g. KICC Convention Centre"
            className={inputClass}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-600 mb-1 block">City *</label>
          <input
            type="text"
            value={value.city}
            onChange={(e) => update('city', e.target.value)}
            placeholder="e.g. Nairobi"
            className={inputClass}
          />
        </div>
        <div className="sm:col-span-2">
          <label className="text-xs font-medium text-gray-600 mb-1 block">Address *</label>
          <input
            type="text"
            value={value.address}
            onChange={(e) => update('address', e.target.value)}
            placeholder="e.g. Harambee Avenue, Nairobi"
            className={inputClass}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-600 mb-1 block">Latitude</label>
          <input
            type="text"
            value={value.latitude}
            onChange={(e) => update('latitude', e.target.value)}
            placeholder="e.g. -1.2921"
            className={inputClass}
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-600 mb-1 block">Longitude</label>
          <input
            type="text"
            value={value.longitude}
            onChange={(e) => update('longitude', e.target.value)}
            placeholder="e.g. 36.8219"
            className={inputClass}
          />
        </div>
      </div>
      {value.latitude && value.longitude && !Number.isNaN(parseFloat(value.latitude)) && !Number.isNaN(parseFloat(value.longitude)) && (
        <div className="rounded-lg border border-gray-200 overflow-hidden">
          <iframe
            title="Location preview"
            className="w-full h-48"
            loading="lazy"
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${parseFloat(value.longitude) - 0.01}%2C${parseFloat(value.latitude) - 0.01}%2C${parseFloat(value.longitude) + 0.01}%2C${parseFloat(value.latitude) + 0.01}&layer=mapnik&marker=${value.latitude}%2C${value.longitude}`}
          />
          <p className="text-xs text-gray-500 px-3 py-2 bg-white border-t border-gray-100">
            Map preview (OpenStreetMap). Coordinates: {value.latitude}, {value.longitude}
          </p>
        </div>
      )}
    </div>
  );
};

export default ManualVenueForm;
